export const TypeColors = {
  Normal: "success",
  Trial: "primary",
  Postpone: "warning",
  Unconfirmed: "info",
  Cancelled: "error",
};